import { CheckoutData, CheckoutPayload } from './types'
import client from '../../client'

export const checkout = (data: CheckoutPayload) => client.post<CheckoutData>('v1/checkout/', data)
